const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');

class CloverDeviceStatusRequestRecord extends AbstractCloverRequestRecord {
    constructor() {
        // @link https://docs.clover.com/reference/device_status
        const url = '/connect/v1/device/status';
        super(
            'GET',
            url
        );
    }
}

module.exports = CloverDeviceStatusRequestRecord;
